import React, { useState, useEffect } from "react";
import ProgressBar from "./ProgressBar";
import { useHistory } from "react-router-dom";
import { useStateValue } from "../ContextAPI/StateProvider";
import { useToasts } from "react-toast-notifications";

const TermsConditionForm = () => {
  const { addToast } = useToasts();
  const history = useHistory();
  const [{ terms }, dispatch] = useStateValue();
  const [value, setvalue] = useState(terms?.checked);

  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    if (!JSON.parse(sessionStorage.getItem("movetotermspage"))) {
      history.push("/registration/customer-information");
      addToast(
        "Error! You cannot proceed furthur before filling previous details",
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
    }
  }, []);

  const submitresult = (e) => {
    if (value === true) {
      dispatch({
        type: "ADD_TO_TERMS",
        terms: {
          checked: value,
        },
      });
      sessionStorage.setItem("movetoconfirmpage", true);
      history.push("/registration/confirm");
    }
  };
  return (
    <form
      id="myForm"
      onSubmit={(e) => {
        e.preventDefault();
        submitresult(e);
      }}
    >
      <div>
        <ProgressBar typeofactive="Terms" />
        <div>
          <div className="form-group">
            <div className="row">
              <div className="col-md-12" style={{ textAlign: "left" }}>
                <label>Terms of Service</label>
                <div
                  className="setfontfamily"
                  style={{
                    width: "100%",
                    height: "500px",
                    overflow: "scroll",
                    border: "#ccc 1px solid",
                    padding: "5px",
                  }}
                >
                  <strong>Parties and Services:</strong>
                  <p>
                    This Agreement for tracking services (“Agreement”) is made
                    between Amcrest Technologies LLC (“Amcrest ”) and the user
                    of Amcrest’s Tracking Service (Customer). Amcrest provides
                    asset location and tracking from the Internet
                    https://amcrestgps.net via the network operations center
                    servers and associated software (“Service(s)”). Services
                    include a secure logon for accessing and tracking
                    individuals and physical assets equipped with an Amcrest
                    tracking device (“Device”) designed to send GPS positions
                    and event notifications (Alerts). GPS tracking coverage is
                    limited by the cellular coverage available from Amcrest’s
                    network partners. Amcrest cannot guarantee the operation of
                    the GPS tracking system in the event of natural or man- made
                    disasters affecting the cellular network, Internet, or the
                    Amcrest servers or their secure location.
                  </p>
                  <strong>Payment:</strong>
                  <p>
                    Upon activation of an Amcrest Device, Customer agrees to pay
                    a monthly fee per asset for Amcrest Services, and to have a
                    valid debit or credit card on file at the Amcrest Service
                    website. Once provided, Customer authorizes Amcrest to
                    charge Customer’s debit or credit card for Services and all
                    amounts due under this Agreement without further notice. If
                    payment is declined, Customer’s Services may be suspended or
                    terminated without notice.
                  </p>

                  <strong>Phone Instructions:</strong>
                  <ul className="ml-3">
                    <li>
                      <strong>Consent to Receive SMS Alerts:</strong> By opting
                      in to receive SMS alerts from Amcrest GPS, you consent to
                      receive text messages on your mobile device for
                      informational and promotional purposes.
                    </li>
                    <li>
                      <strong>Message Frequency:</strong> Message frequency may
                      vary depending on the nature of alerts and promotions. You
                      may receive multiple messages per week.
                    </li>
                    <li>
                      <strong>Cost and Carrier Charges:</strong> Standard
                      message and data rates may apply. Contact your mobile
                      service provider for details on messaging charges.
                    </li>
                    <li>
                      <strong>Privacy and Data Collection:</strong> Amcrest GPS
                      respects your privacy and will only use your mobile number
                      for the purpose of sending SMS alerts. We will not share
                      your information with third parties without your consent.
                    </li>
                    <li>
                      <strong>Customer Support:</strong> For assistance or
                      support related to SMS alerts, please contact{" "}
                      <a href="mailto:amcrestgpssupport@amcrest.com">
                        amcrestgpssupport@amcrest.com.
                      </a>
                    </li>
                    <li>
                      <strong>Changes to Terms and Conditions:</strong> Amcrest
                      GPS reserves the right to update or modify these terms and
                      conditions at any time. Any changes will be effective
                      immediately upon posting on our website.
                    </li>
                    <li>
                      <strong>Governing Law:</strong> These terms and conditions
                      are governed by the laws of United States, and any
                      disputes arising from or relating to these terms shall be
                      resolved in accordance with the laws of United States.
                    </li>
                  </ul>
                  <strong>Rate Changes:</strong>
                  <p>
                    Amcrest may change the rates, fees, expenses, or charges for
                    Service at any time. Amcrest will provide Customers with
                    notice of such changes and, in the case of Service price
                    increases, will notify Customer via Customer’s e-mail
                    address on file with Amcrest, at least one (1) billing cycle
                    in advance. In this instance Amcrest will permit Customer to
                    cancel Services without an early-cancellation penalty
                    providing Customer’s notice of cancellation is delivered to
                    Amcrest within thirty (30) days of Amcrest’s notice to
                    Customer reflecting the change. Customer’s continuing use of
                    Services beyond thirty (30) day notice period will be deemed
                    Customers express agreement to that amendment.
                  </p>
                  <strong>30-Day Money Back Guarantee:</strong>
                  <p>
                    Most of Amcrest’s GPS trackers include a 30-day money back
                    guarantee (may not apply to all tracking devices - contact
                    Amcrest for specific details on included devices). If
                    Customer is dissatisfied with Amcrest’s Service or Device
                    for any reason, Customer will receive a full refund or
                    Customer’s initial subscription, provided that the Device is
                    properly returned and Service Canceled within 30 days of
                    activation. The Device must be returned in its original
                    packaging and the same condition as received; the Device
                    must not show any signs of damage, “wear and tear”, or
                    tampering and must be returned to Amcrest LLC. 16727 Park
                    Row ATTN: RMA DEPT Houston, TX 77084. Shipping must also be
                    made by a method that includes some form of tracking number
                    to confirm receipt of return. After the 30-day money back
                    guarantee period, Customer will be committed to the original
                    terms and conditions accepted at time of purchase. This
                    procedure applies to all returns. Contact support at [email
                    protected] or call (888) 212-7538 . Please include full
                    name, date of purchase, user email address and reason for
                    return.
                  </p>
                  <strong>Subscription Cancellation and Refunds:</strong>
                  <p>
                    Other than as set forth above (30-Day Money Back Guarantee),
                    no partial or prorated refunds for monthly Service will be
                    provided. Charges for Service begin to accrue the day
                    Customer’s Service is activated and continue to accrue until
                    Service is cancelled, whether or not Service is used. Should
                    Customer cancel Service at any time during a billing cycle,
                    Customer will still be able to track their asset through the
                    last day of the billing cycle. Should Services be
                    terminated, there may be a charge to reactivate a Device(s).
                    See https://amcrestgps.net/gps-activation/#/cancellation for
                    cancellation request form. Returning a Device does not
                    automatically cancel Service or prevent accrual of charges
                    for Service. Although Amcrest will do its best to mitigate
                    any new subscription charges, it is ultimately the
                    customer’s responsibility for cancelling the subscription
                    for each device returned. Customer will receive an email
                    confirmation once a request to cancel Service is processed
                    by Amcrest. Customer should save this confirmation, and
                    should contact Amcrest to confirm cancellation if such
                    confirmation is not received within 48 hours.
                  </p>
                  <strong>Account Information/Authorized Users:</strong>
                  <p>
                    It is Customer’s responsibility to maintain current and
                    accurate account information, and to exercise diligence in
                    protecting Customer’s username and passwords. Although
                    Customer may share a password with Customer’s authorized
                    users, Customer does at Customer’s own risk. Customer
                    authorizes Amcrest to provide information about and to make
                    changes to Customer’s account, including adding new service,
                    at the direction of any person able to provide information
                    Amcrest deems sufficient to identify Customer’s account
                    and/or Customer’s authorized users.
                  </p>
                  <strong>Devices and Service Updates:</strong>
                  <p>
                    Amcrest may periodically program Customer’s Device remotely
                    with system settings and other features that cannot be
                    changed manually. Devices purchased for use on Amcrest’s
                    service may not function on other services.
                  </p>
                  <strong>Amendments to Agreement:</strong>
                  <p>
                    Amcrest may amend the terms of this Agreement upon written
                    notice to Customer. If Customer does not agree to the
                    amendment, Customer may terminate this Agreement by
                    providing written notice to Amcrest, by certified U.S. Mail,
                    within fifteen (15) days of the date the notice was mailed
                    by Amcrest. If Customer does not agree with the amendment
                    but wants to continue services, Amcrest will continue to
                    provide services for the term of the original Agreement
                    provided Customer mails written notice to Amcrest within
                    fifteen (15) days of the date the amendment was mailed by
                    Amcrest. Except as specified above, Customer’s continued use
                    of Services for more than fifteen (15) days after Amcrest
                    mails notice of an amendment will be deemed Customers
                    express agreement to that amendment.
                  </p>
                  <strong>Termination of Agreement:</strong>
                  <p>
                    Amcrest may terminate this Agreement at any time without
                    notice if Amcrest ceases to provide service in Customer’s
                    area. Amcrest may interrupt or terminate Customer’s service
                    without notice for conduct that believed to violate this
                    Agreement or any term and conditions of thereof, including
                    but not limited to: a. failure to make timely payments. b.
                    harassing/threatening/or behaving in a derogatory or
                    unreasonable manner with any of Amcrest’s employees or
                    agents c. interfering with Amcrest’s operation or using
                    Services in any manner restricted by or inconsistent with
                    the Agreement or applicable state or federal laws. d.
                    breaching the Agreement, including Amcrest’s Policies e.
                    providing false, inaccurate, dated or unverifiable
                    identification or credit information, or becoming insolvent
                    or bankrupt f. modifying a Device from its manufacturer
                    specifications or g. any conduct which would endanger
                    Amcrest’s interests, any Customer's interests or Amcrest’s
                    network.
                  </p>
                  <strong>Unlawful Use:</strong>
                  <p>
                    Customer agrees not to use the Services or Device(s) for any
                    unlawful or abusive purpose or in any way that would
                    interfere with Amcrest its Services or the Device(s).
                    Customer will comply with all laws while using the Services
                    or Device(s) and will not transmit any communication that
                    would violate any federal, state, or local law, court, or
                    regulation. Resale of the Services or Devices is prohibited
                    except by authorized Dealers. By using the Services and/or
                    any Amcrest Device, Customer agrees to abide by the terms
                    and conditions of any software license agreements applicable
                    to any software associated with the Services or Devices.
                    Attention: Laws and regulations regarding surreptitious
                    usage of GPS tracking devices vary from state to state, and
                    country to country. Customer is advised to seek legal
                    counsel before utilizing a GPS tracking device in such a
                    manner. Amcrest is not liable for any crimes or privacy
                    violations committed by the Customer by using any Amcrest
                    GPS tracking Device.
                  </p>
                  <strong>Unauthorized Use/Alteration of Device:</strong>
                  <p>
                    Customer may not program or otherwise alter any Device other
                    than within the ordinary programmable parameters thereof. If
                    any Device is stolen or Services are used fraudulently,
                    Customer must notify Amcrest immediately and provide Amcrest
                    with such information and documentation as Amcrest may
                    request (including, without limitation, police reports, and
                    affidavits). Amcrest has the right to interrupt Services or
                    restrict service to any Device, without notice to the
                    Customer, if Amcrest reasonably believes Customer’s device
                    is being used in a fraudulent or unlawful manner. Customer
                    will not, and will not allow its users, or agents to,
                    directly or indirectly: reverse assemble, reverse engineer,
                    undo or otherwise attempt to derive source code or
                    underlying ideas or algorithms from the Amcrest Site or
                    hardware, firmware, software or any component; copy,
                    reproduce, modify, translate or create derivative works of
                    the Amcrest Service, or any hardware, firmware, software or
                    component; sell, lease, sub-license, market, distribute,
                    assign or otherwise transfer rights to or commercially
                    exploit in any way the Amcrest Service or any hardware,
                    firmware, software or any component there of other than as
                    expressly agreed to in this Agreement; remove any
                    proprietary, copyright, patent, trade mark; design right,
                    trade secret, or any other proprietary rights legends from
                    Amcrest; disclose or grant access to any user credentials or
                    access codes, the Amcrest Service or any component thereof
                    to any third party, other than one to whom Amcrest has
                    consented to in writing.
                  </p>
                  <strong>Prohibited System/Network Usage:</strong>
                  <p>
                    Data and messaging services and voice communications are
                    provided solely for purposes of sending and receiving GPS
                    tracking information, and programming or reprogramming
                    functions of a GPS tracking device that is authorized by
                    Amcrest tracking service through the Amcrest on-line
                    interface. Any other use of data, messaging service, voice
                    communications or of the SIM card provided by Amcrest, its
                    parent company or subsidiaries or any of its distributors
                    for any other purpose is strictly prohibited. Any use of
                    Amcrest’s GPS trackers or SIM cards for an activity that
                    connects any device to personal computers (including without
                    limitation, laptops), voice communication devices (including
                    without limitation cell phones) or other equipment for the
                    purpose of transmitting or receiving voice communications,
                    wireless data or messaging over the network or for any other
                    reason that, in Amcrest’s sole discretion, violates
                    Amcrest’s Services policy is strictly prohibited. Any
                    alteration to Amcrest’s system or unauthorized automation of
                    any of the features or functions or any Amcrest’s system in
                    any manner other than for which it was designed or intended
                    constitutes a violation or Amcrest’s Services policy.
                    Amcrest will require any Customer violating Amcrest’s
                    Services policy pay for any excess voice, data and messaging
                    use and services associated with the unauthorized use.
                    Device reporting in a manner consistent with Device or
                    system alterations or tampering, or excess of use
                    over-and-beyond the maximum amount that a Device is
                    programmed to transmit or receive based on the Customers
                    Service Plan will be sufficient evidence that unauthorized
                    use of Services has taken place and the excess charges along
                    with any Service fees will be charged to the Customer. An
                    account administration fee of $50 will also be charged for
                    each instance of abuse or misuse of voice, data or messaging
                    services or unauthorized use of a SIM card provided by
                    Amcrest, its parent company, subsidiaries or any of its
                    distributors. To ensure the activities of some Customers do
                    not impair the ability of other Customers to have access to
                    reliable services provided at reasonable costs, Customer may
                    not use Amcrest’s Services in a manner that is unlawful,
                    infringes on intellectual property rights, or harms or
                    unduly interferes with the use of Amcrest’s data provider's
                    network or systems. Amcrest reserves the right, without
                    notice or limitation, to limit data throughput speeds or
                    quantities or to deny, terminate, end, modify, disconnect,
                    or suspend service if Customer or Customer’s users, agents,
                    or employees, engages in any of the prohibited device or
                    data uses detailed below or if Amcrest, in its sole
                    discretion, determines action is necessary to prevent
                    unauthorized activity or to Amcrest’s provider's wireless
                    networks from harm or degradation. Limitation of Liability:
                    Important: These limitations of liability may constitute
                    waivers of important legal rights. Customer acknowledges
                    that these waivers are built in to the Service pricing
                    offered by Amcrest, and absent these limitations, the
                    pricing for Service would be substantially higher. In that
                    regard and unless otherwise prohibited by law, Customer
                    agrees: Customer uses the Device and Service(s) at
                    Customer’s sole risk. Customer agrees that Amcrest is not
                    responsible for acts or omissions of any other third party
                    or service provider, for information provided through the
                    equipment, for equipment failure or modification, for system
                    failure or modification or for causes beyond the control of
                    Amcrest. Customer agrees Amcrest is not liable for: a.
                    service outages b. incidental or consequential damages such
                    as lost profits. c. economic loss or injuries to persons or
                    property arising from the Customer’s use of the Services,
                    the devices or any other equipment used in connection with
                    the devices unless caused by the sole and/or gross
                    negligence of Amcrest. d. the installation or repair of the
                    devices or e. any act associated with the proper exercise by
                    Amcrest of rights under the privacy and/or unauthorized
                    usage provisions of this Agreement. Customer acknowledges
                    that no provider can guarantee that any data or information
                    provided will be error-free and accepts all data and
                    information on an as-is basis. Customer agrees that Amcrest
                    is not liable for any errors or defects in the data and
                    information provided by Amcrest’s Services.
                  </p>
                  <strong>Indemnification:</strong>
                  <p>
                    Customer, along with Customer’s heirs, successors and
                    beneficiaries, agrees to defend, indemnify, and hold Amcrest
                    and its affiliates harmless from claims or damages arising
                    from Customer’s breach of this Agreement or the Customer’s
                    statements made in this Agreement and (ii) the use of the
                    devices or services unless due to sole and/or gross
                    negligence by Amcrest or its affiliates. Customer agrees to
                    pay reasonable attorney’s fees and all applicable costs
                    incurred by Amcrest in enforcing this Agreement. This
                    paragraph shall survive the termination of this Agreement.
                  </p>
                  <strong>Limitation of Action:</strong>
                  <p>
                    Except for actions arising in connection with
                    Indemnification (above), neither Amcrest nor Customer may
                    bring legal action with respect to this Agreement more than
                    one year after the legal action accrues.
                  </p>
                  <strong>Warranties:</strong>
                  <p>
                    Except for actions arising in connection with
                    Indemnification (above), neither Amcrest nor Customer may
                    bring legal action with respect to this Agreement more than
                    one year after the legal action accrues. Warranties: Except
                    as required by applicable law, Amcrest makes no warranties,
                    express or implied, regarding the Service(s) provided and
                    disclaims any and all express or implied warranties,
                    including, without limitation, any warranties of
                    merchantability or fitness for a particular purpose. Amcrest
                    does not authorize anyone to make any warranties on
                    Amcrest’s behalf and Customer should not rely on any such
                    statement. Amcrest does not guarantee, represent, or warrant
                    that Customer’s Service will be uninterrupted or error-free;
                    Customer agrees that from time to time Amcrest may remove
                    the Service for indefinite periods of time or cancel Amcrest
                    Service(s) at any time, without notice to Customer. Customer
                    expressly agrees that Customer’s use of or inability to use
                    the Amcrest Service is at Customer’s sole risk. The Amcrest
                    Service and all products and Services delivered to Customer
                    through the Amcrest Service (except as expressly stated by
                    Amcrest) are provided ‘AS IS’ and ‘AS AVAILABLE.’
                  </p>
                  <strong>Assignment:</strong>
                  <p>
                    Amcrest reserves the right to assign this Agreement, and
                    Amcrest’s rights and duties under the Agreement, in whole or
                    in part, without such assignment being considered a material
                    change to the Agreement. Amcrest will provide notice to
                    Customer of any such assignment, and upon such notice,
                    Customer agrees that Amcrest shall be released from all
                    liability with respect to such rights or duties, or portions
                    thereof. Customer may not assign this Agreement without
                    prior written consent of Amcrest, which shall not be
                    reasonably withheld.
                  </p>
                  <strong>Governing Law:</strong>
                  <p>
                    This Agreement is subject to applicable federal laws and the
                    laws of the State of Texas.
                  </p>
                  <strong>Entire Agreement:</strong>
                  <p>
                    This is the entire Agreement between Amcrest and Customer
                    and supersedes any oral or written promises made to the
                    Customer. This Agreement may only be amended as described
                    herein. If the terms of this Agreement conflict with or are
                    inconsistent with the terms of any purchase order or
                    document provided by the Customer, the terms of this
                    Agreement shall control. If any part of this Agreement is
                    found unenforceable or invalid, the balance of this
                    Agreement shall remain intact.
                  </p>
                  <strong>Privacy Policy:</strong>
                  <p>
                    This is the entire Agreement between Amcrest and Customer
                    and supersedes any oral or written promises made to the
                    Customer. This Agreement may only be amended as described
                    herein. If the terms of this Agreement conflict with or are
                    inconsistent with the terms of any purchase order or
                    document provided by the Customer, the terms of this
                    Agreement shall control. If any part of this Agreement is
                    found unenforceable or invalid, the balance of this
                    Agreement shall remain intact. Privacy Policy: Customer
                    privacy is important to Amcrest. Amcrest will never sell or
                    loan a Customer’s personal information to third parties for
                    marketing purposes. The personal information Customer
                    furnishes online will be used to help Amcrest provide
                    Amcrest’s Customers the highest quality products, services
                    and support. Amcrest will not monitor, edit, or disclose any
                    personal information about Customer or Customer’s Amcrest
                    account, including its contents, without Customer’s prior
                    permission, unless Amcrest has a good faith belief that such
                    action is necessary to: a. conform to legal requirements or
                    comply with legal process b. protect and defend the rights
                    or property of Amcrest . c. enforce the Agreement or protect
                    Amcrest's business or reputation, including upon
                    termination, cancellation or suspension of this Agreement by
                    Amcrest . d. respond to any request for identification in
                    connection with claim of copyright or trademark infringement
                    by you e. prevent imminent physical injury or harm to any
                    person or prevent any suspected infringing, illegal or
                    improper activity; in either of which event, such
                    information shall be disclosed to any law enforcement agency
                    making such request; or f. act to protect the interests of
                    Amcrest’s Customers. Customer agrees that Amcrest may access
                    Customer’s account, including its contents, as stated above
                    or to respond to service or technical issues.
                  </p>
                </div>
                <div style={{ display: "flex", paddingTop: "20px" }}>
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setvalue(true);
                      } else {
                        setvalue(false);
                      }
                    }}
                    style={{ marginRight: "10px", marginTop: "7px" }}
                  />
                  I HAVE READ AND AGREE TO THE ABOVE MENTIONED AND CONDITIONS OF
                  SERVICE AGREEMENT.
                </div>
              </div>
            </div>
          </div>
          <div
            className="activation"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <button
              className="btn "
              style={{ backgroundColor: "#ccc", borderColor: "#ccc" }}
              onClick={() => {
                sessionStorage.setItem("movetotermspage", false);
                history.push("/registration/payment-method");
              }}
            >
              Previous
            </button>
            <button
              disabled={!value}
              className={
                !value ? "btn btn-primary buttondisabled" : "btn btn-primary"
              }
              type="submit"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default TermsConditionForm;
